// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__O8z4z","main-image":"Header_main-image__aQXy3"};